import { useContext } from 'react';
import {
  ApiFilterOperation,
  AuthoredEvidence,
  TableCells,
  TableColumn,
  TableFilterCells,
  useStaticListSource,
} from '@eas/common-web';
import { useAuditingEntities } from '@modules/auditor/auditor-api';
import { StaticDataContext } from '@components/evidence/static-data-provider';
import { autocompleteLabelMapper } from '@components/form/misc/label-mappers';
import { AuditingEntityAutocomplete, LicenceApplication } from '@models';

export function useColumns(): TableColumn<LicenceApplication>[] {
  const { authoredColumns } =
    AuthoredEvidence.useAuthoredColumns<LicenceApplication>();

  const { licenceApplicationStates } = useContext(StaticDataContext);
  const useStates = () => useStaticListSource(licenceApplicationStates);

  return [
    {
      datakey: 'state',
      sortkey: 'state.name',
      filterkey: 'state.id',
      name: 'Stav',
      width: 200,
      CellComponent: TableCells.TextCell,
      valueMapper: TableCells.useSelectCellFactory(useStates),
      FilterComponent: TableFilterCells.useFilterSelectCellFactory(useStates),
      filterOperation: ApiFilterOperation.EQ,
      sortable: true,
      filterable: true,
      filterGroup: 1,
    },
    {
      datakey: 'applicant.label',
      sortkey: 'applicant.name',
      filterkey: 'applicant.id',
      name: 'Žiadateľ',
      width: 300,
      CellComponent: TableCells.TextCell,
      filterOperation: ApiFilterOperation.EQ,
      FilterComponent:
        TableFilterCells.useFilterAutocompleteCellFactory<AuditingEntityAutocomplete>(
          useAuditingEntities,
          autocompleteLabelMapper
        ),

      sortable: true,
      filterable: true,
      filterGroup: 1,
    },
    {
      datakey: 'email',
      name: 'Kontaktný e-mail',
      width: 200,
      CellComponent: TableCells.TextCell,
      sortable: true,
      filterable: true,
      filterGroup: 1,
    },
    {
      datakey: 'phone',
      name: 'Kontaktné telefónne číslo',
      width: 150,
      CellComponent: TableCells.TextCell,
      sortable: true,
      filterable: true,
      filterGroup: 1,
    },
    {
      datakey: 'processUntil',
      name: 'Najneskorší termín rozhodnutia',
      width: 150,
      CellComponent: TableCells.DateCell,
      sortable: true,
      filterable: true,
      filterGroup: 2,
    },
    {
      datakey: 'decisionDate',
      name: 'Dátum rozhodnutia',
      width: 150,
      CellComponent: TableCells.DateCell,
      sortable: true,
      filterable: true,
      filterGroup: 2,
    },
    {
      datakey: 'forAuditor',
      name: 'Žiadosť pre zápis ŠA',
      width: 150,
      CellComponent: TableCells.BooleanCell,
      sortable: true,
      filterable: true,
      filterGroup: 1,
    },
    {
      datakey: 'forAuditCompany',
      name: 'Žiadosť pre zápis AS',
      width: 150,
      CellComponent: TableCells.BooleanCell,
      sortable: true,
      filterable: true,
      filterGroup: 1,
    },
    ...authoredColumns.map((c) => ({ ...c, filterGroup: 3 })),
  ];
}
